var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('payout-form-group',{scopedSlots:_vm._u([{key:"labelinner",fn:function(){return [_vm._v(" ")]},proxy:true}])},[_c('div',{staticClass:"form-control-filtered-wrapper"},[_c('payout-form-checkbox',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"label":_vm.label},on:{"input":_vm.onUpdate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }